<template>
  <div class="w-11/12 mx-auto flex-row flex-wrap justify-between font-costea">

    <div class="flex flex-row justify-between pt-3 pb-2 mb-6 mt-2 border-b-2 flex-wrap">
      <h1 class="font-costea text-xl font-medium text-costeaBlack mb-4 md:mb-0">
        Gestión de componentes
      </h1>
      <div class="flex flex-row lg:flex-nowrap sm:items-center items-start flex-wrap gap-2">

        <div class="flex justify-center items-center flex-row sm:mr-4 ">
          <div class="flex flex-row bg-white items-center justify-center px-2 w-24 h-10 box-border text-costeaBlack text-t14 rounded-l-md">
            <i class="ri-exchange-dollar-line mr-1"></i>
            <input type="number" name="tasaCambio" id="tasaCambio" v-model="tasaCambio" class="w-16 outline-none bg-transparent placeholder-gray-500"
              placeholder="TRM">
          </div>
          <button @click="actualizarTasaCambio()" class="flex flex-row justify-center items-center bg-costeaPrimary text-white hover:bg-costeaHover h-10 px-2 rounded-r-md">
            <i class="ri-refresh-line"></i>
            <span v-show="this.actualizandoTasaCambio">Actualizando...</span>
          </button>
        </div>

        <div class="flex flex-row justify-center items-center sm:mx-2">
          <select v-model="filtroOrden" class="px-2 py-2 rounded-md h-10 sm:mx-2 text-t14 text-costeaGray">
            <option value="0">Ordenar por:</option>
            <option value="1">Costo menor a mayor</option>
            <option value="2">Costo mayor a menor</option>
          </select>
        </div>

        <div
          class="flex flex-row justify-center items-center sm:mx-2">
          <select v-model="typeSearch" class="px-2 py-2 rounded-md h-10 sm:mx-2 text-t14 text-costeaGray">
            <option value="1">Nombre</option>
            <option value="2">Referencia</option>
          </select>
        </div>

        <div
          class="flex flex-row bg-white items-center justify-center px-2 py-3 w-48 h-10 box-border text-costeaGray text-t14 rounded-md">
          <i class="ri-search-line mx-2"></i>
          <input type="text" name="searchInput" id="searchInput" v-model="searchInput" class="w-40 outline-none pr-2"
            placeholder="Buscar Componentes">
        </div>

        <div class="flex items-center gap-2 h-10">
        <p class="text-costeaGray sm:ml-6 mr-3 text-t14">
          <span class="text-costeaBlack font-medium">{{ page }}</span> de <span>{{ getPageNumber() }}</span>
        </p>

        <div class="flex flex-row h-full">
          <button class="w-10 mr-1 bg-costeaBtn2 hover:bg-costeaBtn2Hover text-costeaGray opacity-50"
            @click="page--, getPageNumber()" v-if="page != 1"><i class="ri-arrow-left-line"></i></button>
          <button class="w-10 bg-costeaBtn2 hover:bg-costeaBtn2Hover text-costeaGray" @click="page++, getPageNumber()"
            v-show="page < getPageNumber()"><i class="ri-arrow-right-line"></i></button>
        </div>
      </div>
        <!--<download-excel name="Componentes"
          class="flex justify-center items-center bg-costeaDarkGreen text-white font-costea text-sm w-12 h-10 ml-3 transition cursor-pointer rounded-md hover:bg-green-600 relative buttonExcel"
          :data="JsonToXlsx">
          <i class="ri-file-excel-2-fill text-xl"></i>
          <span
            class="bg-gray-600 text-white px-2 py-1 text-xs rounded-full absolute w-28 -bottom-12 right-0 opacity-0 buttonExcelToolTip">Exportar
            a Excel</span>
        </download-excel>-->
        <button @click="this.JsonToXlsx" v-if="!downloadExcel"
          class="flex justify-center items-center bg-costeaDarkGreen text-white font-costea text-sm w-12 h-10 ml-3 transition cursor-pointer rounded-md hover:bg-green-600 relative buttonExcel">
          <i class="ri-file-excel-2-fill text-xl"></i>
          <span
            class="bg-gray-600 text-white px-2 py-1 text-xs rounded-full absolute w-28 -bottom-12 right-0 opacity-0 buttonExcelToolTip">Exportar
            a Excel</span>
        </button>

        <vue-excel-xlsx
        v-if="rol_usuario != 3 && downloadExcel"
        class="flex justify-center items-center bg-costeaPrimary text-white font-costea text-sm w-12 h-10 ml-3 transition cursor-pointer rounded-md hover:bg-costeaHover relative buttonExcel"
        :data="this.columnasExcel[0]"
        :columns="this.columnasExcel[1]"
        :file-name="'componentes'"
        :file-type="'xlsx'"
        :sheet-name="'Componentes'"
        >
        <i class="ri-download-cloud-2-line text-xl"></i>
          <span
            class="bg-gray-600 text-white px-2 py-1 text-xs rounded-full absolute w-28 -bottom-12 right-0 opacity-0 buttonExcelToolTip">Descargar</span>
        </vue-excel-xlsx>
      </div>
    </div>

    <div class="grid grid-cols-12 gap-2 pb-10">
      <!--<div class="col-start-1 col-end-13 p-2 rounded-md">
              <div class="h-10 flex flex-row items-center font-costea text-t14">
                <input type="checkbox" class="w-4 h-4 rounded-sm border-2 mr-2">
                <span class="px-2 cursor-pointer text-costeaDarkGray">Seleccionar todos</span>
              </div>
          </div>-->

      <div class="col-start-1 col-end-13 grid grid-cols-1 gap-6 md:grid-cols-3 xl:grid-cols-4 sm:grid-cols-2">

        <article v-for="comp in this.displayedComponents" :key="comp.index" class="rounded-md overflow-hidden flex flex-col items-center justify-center bg-white h-96">
          
          <header class="-mt-0">  
            <div class="relative" style="background-color: #E6E8ED;">
              <img class="object-contain h-36 w-96 object-top " :src="`${showImage(comp.picture)}`" alt="">
              <span
                class="text-white w-auto right-2 top-2 flex flex-row absolute bg-costeaDarkYellow text-t14 p-2 rounded-md">
                <i class="ri-time-line mr-2"></i>
                <span><span>{{ comp.tipo_materia_prima === 'Nacional' ? interNumberFormat(comp.costo_unitario) : interNumberFormat(comp.costo_unitario * comp.tasa_de_cambio)}}</span> </span>
              </span>
            </div>
          </header>

          <main class="border-costeaContainer w-11/12 h-44 text-t12 leading-5 text-costeaGray px-5 pt-6 border-b-2 flex flex-col justify-start ">
            <h4 class="text-costeaBlack font-medium text-t14 pb-2">{{ comp.name }}</h4>
            <article>
              <p>Referencia: <span class="text-costeaBlack font-medium">{{ comp.referencia }}</span></p>
              <p>Unidad de medida: <span class="text-costeaBlack font-medium">{{ comp.unidad_de_medida }}</span></p>
              <p>Tipo de materia prima: <span class="text-costeaBlack font-medium">{{ comp.tipo_materia_prima }}</span></p>
              <p>Costo unitario: 
                <span
                  class="text-costeaBlack font-medium">
                  {{ interNumberFormat(comp.costo_unitario) }}
                </span>
              </p>
            </article>
          </main>

          <section class="flex justify-end flex-row w-full  px-5 py-4 text-t14">

            <button @click="showModalDelete(comp.name, comp.id)"
              class="hover:bg-costeaSalmonDisabled hover:text-costeaSalmon w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 text-costeaGray">
              <i class="ri-delete-bin-6-line"></i>
            </button>

            <button @click="showModalEdit(
              comp.name,
              comp.id,
              comp.referencia,
              '1234CB',
              comp.unidad_de_medida,
              comp.costo_unitario,
              comp.tasa_de_cambio,
              comp.tipo_materia_prima)"
              class="hover:text-costeaPrimary hover:bg-costeaPrimaryDisabled w-8 h-8 ml-2 flex items-center justify-center rounded-full text-costeaGray bg-gray-100">
              <i class="ri-edit-line"></i>
            </button>

          </section>

        </article>

      </div>
    </div>

    <transition name="fade">
      <component v-show="this.modalAdd" :is="Add" @closeModalAdd="handleAddCloseModal" @reloadData='reloadData' />
    </transition>
    <transition name="fade">
      <component :componentOld="editName" :componentId="editId" :referencia="referencia" codigoBarras="1234CB"
        :unidadMedida="unidad_de_medida" :costoUnitario="costo_unitario" :tasaCambio="tasa_de_cambio"
        :materiaPrima="tipo_materia_prima" v-show="this.modalEdit" :is="edit" @closeModalEdit="handleEditCloseModal"
        @reloadData='reloadData' />
    </transition>
    <transition name="fade">
      <component :componenteOld="deleteName" :componenteId="deleteId" v-show="this.modalDelete" :is="Delete"
        @closeModalDelete="handleDeleteCloseModal" @reloadData='reloadData' />
    </transition>

    <buttonAdd @showModal="handleAddOpenModal" />
  </div>

</template>

<script>
import buttonAdd from '@/components/elements/ButtonAdd.vue'
import componentAdd from '@/components/componentes/AddComponents.vue'
import componentEdit from '@/components/componentes/EditComponents.vue'
import componentDelete from '@/components/componentes/DeleteComponents.vue'
import axios from 'axios'
import { mapState } from 'vuex'

export default {
  name: "Areas",
  components: {
    buttonAdd,
    componentAdd,
    componentEdit,
    componentDelete
  },
  data() {
    return {
      cop: false,
      usd: false,
      mensaje: false,
      accion: 'Null',
      rol_usuario: localStorage.getItem("rol_usuario"),

      modalAdd: false,
      modalEdit: false,
      modalDelete: false,
      Add: 'componentAdd',
      Delete: 'componentDelete',
      components: [],
      page: 1,
      pages: [],
      elementsPerPage: 8,
      editName: '',
      editId: '',
      deleteName: '',
      deleteId: '',
      downloadExcel:false,
      columnasExcel: [],
      searchInput: "",
      typeSearch: "1",
      tasaCambio: '',
      actualizandoTasaCambio: false,

      name: '', referencia: '', codigo_de_barras: '', unidad_de_medida: '', tipo_materia_prima: '', costo_unitario: '', tasa_de_cambio: '', cantidad: '', costo_total: '',
      secretWord: localStorage.getItem('secret-word'),
      filtroOrden: '0'
    }
  },
  computed: {
    
    ...mapState(['costea']),
    displayedComponents() {
      if (this.searchInput == "" && this.filtroOrden == "") {
        return this.paginate(this.components);
      }
      if(this.filtroOrden != "" && this.searchInput == ""){
        return this.paginate(this.ordenar);
      }
      if(this.searchInput != "" && this.filtroOrden == ""){
        return this.paginate(this.findsearchInput);
      }else{
        return this.paginate(this.findsearchInput)
      }
    },
    findsearchInput() {
      let components = '';
      if (this.typeSearch == "1" || this.typeSearch == "") {
        components = this.components.filter(components => {
          return components.name.toLowerCase().includes(this.searchInput.toLowerCase())
        })
      } else if (this.typeSearch == "2") {
        components = this.components.filter(components => {
          return components.referencia.toLowerCase().includes(this.searchInput.toLowerCase())
        })
      }
      return components;
    },
    edit() {
      if (this.modalEdit === true) {
        return 'componentEdit'
      } else {
        return ''
      }
    },
    ordenar(){
        let data = this.components
        if(this.filtroOrden == '0'){
          data.sort((a, b) => a.id - b.id)
        }
        //ordenar de menor a mayor y mayor a menor del costo_total_del_area
        if(this.filtroOrden == '1'){
          //ordernar de menor a mayor el costo_total_del_area
          data.sort((a, b) => a.costo_unitario - b.costo_unitario)
        }
        if(this.filtroOrden == '2'){
          //ordenar de mayor a menor el costo_total_del_area
          data.sort((a, b) => b.costo_unitario - a.costo_unitario)
        }
        return data
    },
    
  },
  methods: {
    JsonToXlsx() {
      let componentes = this.components;
      let componentesJson = [];
      componentes.forEach(component => {
        let componente = {
          "Nombre": component.name,
          "Referencia": component.referencia,
          "Unidad de medida": component.unidad_de_medida,
          "Tipo de materia prima": component.tipo_materia_prima,
          "Costo unitario": component.tipo_materia_prima === 'Nacional' ? (component.costo_unitario * 1) : ((component.costo_unitario * component.tasa_de_cambio)*1)
        }
        componentesJson.push(componente)
      })

      let columns = [
        {
          label: "Nombre",
          field: "Nombre",
        },
        {
          label: "Referencia",
          field: "Referencia",
        },
        {
          label: "Unidad de medida",
          field: "Unidad de medida",
        },
        {
          label: "Tipo de materia prima",          
          field: "Tipo de materia prima",
        },
        {
          label: "Costo unitario",
          field: "Costo unitario",
        }
      ]
      this.downloadExcel= true
      this.columnasExcel = [componentesJson, columns];

    },
    actualizarTasaCambio() {
      this.actualizandoTasaCambio = true;
      axios.put(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}componente-trm`, {trm: this.tasaCambio})
        .then(response => {
          console.log(response)
          this.getComponents();
          this.actualizandoTasaCambio = false;
          this.tasaCambio = '';
        })
        .catch(error => {
          console.log(error)
          this.actualizandoTasaCambio = false;
          this.tasaCambio = '';
        })
    },
    interNumberFormat(number) {
      let interNF = new Intl.NumberFormat('es-CO');
      let numberDecimals = parseFloat(number)
      numberDecimals = numberDecimals.toFixed(2)
      return isNaN(number) ? number : interNF.format(numberDecimals)
    },
    showImage(imagen) {
      if (imagen != null) {
        let imageFromServer = this.costea.protocol + this.secretWord + '.backend.costea.com.co/' + imagen;
        return `${imageFromServer}`
      } else {
        return `/img/costea-placeholder.png`
      }
    },
    getComponents: function () {
      axios
        .get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}componentes`)
        .then(respuesta => {
          if (respuesta.data.status == false) {
            this.$router.push('/login')
          }
          this.components = respuesta.data;
          this.pages = []
          this.setPages()
        }).catch((error) => {
          console.log(error)
        })
    },
    reloadData(value) {
      if (value === true) {
        this.getComponents()
        value = false
      } else {
        console.log('Ocurrio un error')
      }
    },


    //Handles
    handleAddOpenModal(value) {
      this.modalAdd = value
    },
    handleAddCloseModal(value) {
      this.modalAdd = value
    },
    handleEditCloseModal(value) {
      this.modalEdit = value
    },
    handleDeleteCloseModal(value) {
      this.modalDelete = value
    },

    showModalEdit(name, id, referencia, codigoBarras, unidadMedida, costoUnitario, tasaCambio, materiaPrima) {
      if (this.modalEdit === false) {
        this.modalEdit = true
        this.editName = name
        this.editId = id
        this.referencia = referencia
        this.codigo_de_barras = codigoBarras
        this.unidad_de_medida = unidadMedida
        this.costo_unitario = costoUnitario
        this.tasa_de_cambio = tasaCambio
        this.tipo_materia_prima = materiaPrima
      } else {
        this.modalEdit = false
      }
    },
    showModalDelete(name, id) {
      if (this.modalDelete === false) {
        this.modalDelete = true
        this.deleteName = name
        this.deleteId = id
      } else {
        this.modalDelete = false
      }
    },

    //Paginado
    setPages() {
      let numberOfPages = Math.ceil(this.components.length / this.elementsPerPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(obj) {
      let page = this.page;
      let perPage = this.elementsPerPage;
      let from = (page * perPage) - perPage;
      let to = (page * perPage);
      return obj.slice(from, to);
    },
    getPageNumber() {
      return this.pages.length
    }
  },
  beforeMount() {
    if (localStorage.getItem('token')) {
      this.getComponents()
    } else {
      this.$router.push('/login')
    }

  },
}
</script>

<style>
</style>